import { z } from 'zod';
import { VISIT_STATUSES } from '../visit-state.js';
/** Query filters shared by every dashboard endpoint. Dates are ISO dates or date-times. */
export const dashboardFiltersSchema = z.object({
    from: z.string().datetime({ offset: true }).or(z.iso.date()).optional(),
    to: z.string().datetime({ offset: true }).or(z.iso.date()).optional(),
    clusterId: z.coerce.number().int().positive().optional(),
    facilityId: z.coerce.number().int().positive().optional(),
    technicianId: z.coerce.number().int().positive().optional(),
});
export const dashboardSummarySchema = z.object({
    range: z.object({ from: z.string(), to: z.string() }),
    totals: z.object({
        visits: z.number(),
        byStatus: z.record(z.enum(VISIT_STATUSES), z.number()),
    }),
    openRequests: z.object({
        count: z.number(),
        oldestDays: z.number().nullable(),
        averageAgeDays: z.number().nullable(),
    }),
    csatAverage: z.number().nullable(),
    onTime: z.object({
        checkedIn: z.number(),
        onTime: z.number(),
        rate: z.number().nullable(),
        toleranceMinutes: z.number(),
    }),
    validation: z.object({
        completed: z.number(),
        validated: z.number(),
        ratio: z.number().nullable(),
        averageHoursToSignOff: z.number().nullable(),
        lateValidations: z.number(),
    }),
});
export const visitsByTechRowSchema = z.object({
    technicianId: z.number(),
    technician: z.string(),
    month: z.string(),
    status: z.enum(VISIT_STATUSES),
    count: z.number(),
});
export const csatByFacilityRowSchema = z.object({
    facilityId: z.number(),
    facility: z.string(),
    average: z.number(),
    count: z.number(),
});
export const onTimeRowSchema = z.object({
    technicianId: z.number(),
    technician: z.string(),
    checkedIn: z.number(),
    onTime: z.number(),
    rate: z.number(),
});
export const visitsByFacilityRowSchema = z.object({
    facilityId: z.number(),
    facility: z.string(),
    count: z.number(),
});
//# sourceMappingURL=dashboard.js.map